import {
  Button,
  CircularProgress,
  Grid,
  makeStyles,
  Theme,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import firebase from "firebase";
import _ from "lodash";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import queryString from "query-string";

import { verifyAuthTokenWithServer } from "../../../../services/accountApp/authService";
import { createCustomToken } from "../../../../services/globalService";
import { useHistory, useRouteMatch } from "react-router-dom";
import SignInPage from "./SignInPage";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export interface ManageAppsProps {}

/* Get all location information using API call at initial load. */
const MobileAppSignIn: React.FunctionComponent<ManageAppsProps> = () => {
  const history = useHistory();
  const match: any = useRouteMatch();


  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SignInPage  />
    </div>
  );
};

export default MobileAppSignIn;
